import { mapState } from 'vuex';


export default {
    name: 'wai_payload_wizard_query',
    props: {
        payload : Object,
        additional : Object
    },

    data : function(){

       return {

       }

    },

    created : function(){
 
    },

    watch: {
        
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    methods : {
        cui : function(symptoms){
            var t = this

            if(!(symptoms || []).map){
                symptoms = JSON.parse(symptoms)
            }

            return (symptoms || []).map((v, i) => {

                var cuiinfo = t.$f.deep(t.$store, 'state.cache.CUI.' + (v.cui || v).toUpperCase())

                if(!cuiinfo){
                    return "<b>" + (v.cui || v) + (v.p ?  " | " + Number(v.p).toFixed(2) + "" : "") + ":</b> " + 'CUI WITHOUT INFO'
                }

                if (cuiinfo.Name) return "<b>" + (v.cui || v) + (v.p ?  " | " + Number(v.p).toFixed(2) + "" : "") + ":</b> " + t.$f.flball(cuiinfo.Name) 

            }).filter((v, i) => {
                return v
            }).join(';<br> ')

        },


        result : function(tsymptoms){
            var t = this

            return (tsymptoms || []).map((v, i) => {

                if (v.CUIName) return "<b>" + v.CUI + ",</b> " + " (" +v.p.toFixed(2)+ "): " + t.$f.flball(v.CUIName) 

            }).filter((v, i) => {

                return v

            }).join(';<br> ')

        }

        
    }

   

   
}